import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import isNativeApp from '../../util/is-native-app';

const NativeAppAwareContainer = ({ device, children }) => (
    <div className={ classnames({ nativeAppContext: isNativeApp(device) }) }>
        { children }
    </div>
);

NativeAppAwareContainer.propTypes = {
    device: PropTypes.string,
    children: PropTypes.node,
};

NativeAppAwareContainer.defaultProps = {
    device: 'desktop',
    children: [],
};
const mapStateToProps = state => ({
    device: state.device,
});

// noinspection JSUnusedGlobalSymbols
export default connect(mapStateToProps)(NativeAppAwareContainer);
